module.exports = __webpack_public_path__ + "static/picker@2x-ef4f2cc7743fd02e1354d01cf3567908.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/design/picker@2x.png
// module id = 2591
// module chunks = 168707334958949